import { isDev } from "./../tools/envs";
import { wujiRequest } from "../core/common/wujiRequest";
/**
 * 文档数据
 */
class DocService {
  async list() {
    const params = {
      size: 'total',
      filter: 'disabled=0',
      sort: '_sort',
      order: 'desc'
    };
    if (isDev) {
      Object.assign(params, {
        nocache: '1'
      });
    }
    const res = await wujiRequest({
      url: '/api/xy/doc/list',
      params,
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    const data = res.code === 200 ? res.data : [];
    data.forEach(item => {
      try {
        item.keywords = JSON.parse(item.keywords);
      } catch (error) {
        item.keywords = [item.title];
      }
    });
    return data;
  }
  async docTypeList() {
    const params = {
      size: 'total',
      exclude: '_ctime,_mtime',
      sort: '_sort',
      order: 'asc'
    };
    if (isDev) {
      Object.assign(params, {
        nocache: '1'
      });
    }
    const res = await wujiRequest({
      url: '/api/xy/doc_type/list',
      params,
      method: 'get',
      headers: {
        'content-type': 'application/json'
      }
    });
    const data = res.code === 200 ? res.data : [];
    return data;
  }
}
export const docService = new DocService();
//# sourceMappingURL=docService.js.map
